import { useTranslation } from 'react-i18next'

import { attachRequest } from '../../../../api'
import { useInitData, useNotification } from '../../../../hooks'
import { AttachServiceRequestsModal } from '../../../Request'
import {
  EMAIL_ACTION_ATTACH_REQUEST,
  EMAIL_TABLE_ROW_ACTIONS_CONFIG,
} from '../../Email.constants'

import {
  getEmailAttachRequestErrorKey,
  getEmailAttachRequestExcludeRequestIds,
  getEmailAttachRequestPayload,
  getEmailAttachRequestSuccessNotifications,
} from './useEmailAttachRequest.utils'

export function useEmailAttachRequest({
  actionName = EMAIL_ACTION_ATTACH_REQUEST,
  getPayload = getEmailAttachRequestPayload,
  getSuccessNotifications = getEmailAttachRequestSuccessNotifications,
  successTitle,
  onCloseModal,
  onErrorAction,
  onSetModal,
  onSuccessAction,
}) {
  const { t } = useTranslation()

  const { handleAddErrorNotification } = useNotification()

  const { availableSections } = useInitData()

  async function handleAttachRequest({ entityId, id, name, selected, status }) {
    const archived = selected?.[0]?.archived

    return attachRequest(id, getPayload({ entityId, id, status }))
      .then(() => {
        onSuccessAction(
          actionName,
          getSuccessNotifications({
            archived,
            availableSections,
            id,
            name,
            status,
            successTitle,
            t,
          })
        )
      })
      .catch(() => {
        const handleError = onErrorAction || handleAddErrorNotification

        handleError(getEmailAttachRequestErrorKey({ archived, status }))
      })
      .finally(() => {
        onCloseModal()
      })
  }

  function handleOpenAttachServiceRequestModal({
    getExcludeIds = getEmailAttachRequestExcludeRequestIds,
    item,
  }) {
    onSetModal(
      <AttachServiceRequestsModal
        changeStatusAttention
        aiSuggestEmailUuid={item[EMAIL_TABLE_ROW_ACTIONS_CONFIG.itemIdKey]}
        entityId={item[EMAIL_TABLE_ROW_ACTIONS_CONFIG.itemIdKey]}
        excludeIds={getExcludeIds(item)}
        onAttach={handleAttachRequest}
        onClose={onCloseModal}
      />
    )
  }

  return {
    handleAttachRequest,
    handleOpenAttachServiceRequestModal,
  }
}
